var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5737 15.5161C18.1419 16.0843 18.1419 17.0056 17.5737 17.5738C17.0055 18.1421 16.0842 18.1421 15.516 17.5738L8.99999 11.0578L2.484 17.5738C1.91578 18.1421 0.994521 18.1421 0.426303 17.5738C-0.141916 17.0056 -0.141916 16.0843 0.426303 15.5161L6.94229 9.00007L0.426164 2.48389C-0.142055 1.91566 -0.142055 0.994392 0.426164 0.426168C0.994383 -0.142055 1.91565 -0.142056 2.48386 0.426167L8.99999 6.94235L15.5161 0.426167C16.0843 -0.142056 17.0056 -0.142055 17.5738 0.426168C18.142 0.994392 18.142 1.91566 17.5738 2.48389L11.0577 9.00007L17.5737 15.5161Z",
    fill: "#80829D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnX);
export default __webpack_public_path__ + "static/media/btn-x.a12e87811568ae71953eb371e27c347e.svg";
export { ForwardRef as ReactComponent };